import { render, staticRenderFns } from "./Affix.vue?vue&type=template&id=74f464ac&scoped=true"
import script from "./Affix.vue?vue&type=script&lang=js"
export * from "./Affix.vue?vue&type=script&lang=js"
import style0 from "./Affix.vue?vue&type=style&index=0&id=74f464ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f464ac",
  null
  
)

export default component.exports